import React from 'react';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../../components/ui/button';
import { CalendarIcalBackup } from '../../components/admin/CalendarIcalBackup';
import { CalendarConfirmDialog } from '../../components/admin/CalendarConfirmDialog';

export default function AdminCalendarSync() {
  const [ical, setIcal] = React.useState(null);
  const [loading, setLoading] = React.useState(true), [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState(''), [confirmation, setConfirmation] = React.useState(false);
  const [notice, setNotice] = React.useState('');
  const sequence = React.useRef(0);
  const load = React.useCallback(async () => {
    const current = ++sequence.current;
    try {
      const { data } = await api.get('/admin/calendar/token');
      if (current !== sequence.current) return;
      setIcal(data); setError('');
    } catch {
      if (current === sequence.current) setError('Le lien iCal n’est pas disponible. Réessayez avec Actualiser.');
    } finally {
      if (current === sequence.current) setLoading(false);
    }
  }, []);
  React.useEffect(() => {
    load();
    return () => { sequence.current += 1; };
  }, [load]);
  const act = async fn => {
    setBusy(true); setError('');
    try { await fn(); } catch (e) { setError(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'L’action a échoué. Veuillez réessayer.'); }
    finally { setBusy(false); }
  };
  const copy = async text => {
    try { await navigator.clipboard.writeText(text); toast.success('Lien copié'); setNotice('Lien copié.'); }
    catch { setError('Copie indisponible. Vous pouvez sélectionner le lien affiché.'); }
  };
  const confirm = () => act(async () => {
    await api.post('/admin/calendar/rotate-token');
    setIcal(null);
    setNotice('Nouveau lien iCal créé. L’ancien lien est invalide.');
    setConfirmation(false); await load();
  });
  return <div className="text-text-cream max-w-4xl min-w-0" data-testid="admin-calendar-sync-page">
    <header className="mb-10 flex flex-wrap items-start justify-between gap-5"><div><p className="eyebrow mb-3">Organisation du studio</p><h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" data-testid="calendar-page-title">Agenda du studio</h1></div><Button variant="ghost" className="gap-2" disabled={busy || loading} onClick={() => act(load)} data-testid="calendar-refresh"><RefreshCw size={16}/>Actualiser</Button></header>
    {error && <p role="alert" className="text-red-300 text-sm mb-5" data-testid="calendar-page-error">{error}</p>}
    {notice && <p role="status" className="text-accent-light text-sm mb-5" data-testid="calendar-page-notice">{notice}</p>}
    {loading ? <p role="status" data-testid="calendar-loading">Chargement…</p> : <CalendarIcalBackup data={ical} busy={busy} copy={copy} rotate={() => setConfirmation(true)}/>}
    <CalendarConfirmDialog open={confirmation} busy={busy} close={() => setConfirmation(false)} confirm={confirm}/>
  </div>;
}